import React, { useEffect, useContext } from "react";
import useForm from "../../../../services/UseForm";
import validate from '../../../../validations/admin/basicInfo/paymentTypeValidate';
import '../../../../css/popUpForm.css';
import axios from "axios";
import { API } from "../../../../services/api";
import { PaymentTypeContext } from "../paymentType";

axios.defaults.baseURL = API;

function UpdatePaymentType(props) {

    const {dataList, setDataList, data} = useContext(PaymentTypeContext);

    const handleInputStatusChange = event => {
        const { name, value } = event.target;
        handleChange(name, value)
        check(value);
    };

    const check = (params) => {
        const results = dataList.filter((data) => {
            return data.PaymentType.toLowerCase() === params.toLowerCase()
        });
        if (results.length > 0)
            handleChange("CheckPaymentType", results[0].PaymentType);
        else
            handleChange("CheckPaymentType", "");
    }

    async function update() {
        let token = localStorage.getItem("token");
        var data = {
            PaymentType: values.PaymentType
        }
        await axios.put(`/updatePaymentType/${values.PaymentTypeID}`, data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {

            for (var i=0; i < dataList.length; i++) {
                if (dataList[i].PaymentTypeID == values.PaymentTypeID) {
                    dataList[i].PaymentType = values.PaymentType;
                    localStorage.setItem("paymentTypeData", JSON.stringify(dataList));
                    break;
                }
            }  
            setDataList(dataList);
            ClearData();
            props.onClick(false);
        }).catch((err) => {
            console.log(err);
        });
    };

    const ClearData = () => {
        handleChange("PaymentTypeID", "");
        handleChange("PaymentType", "");
    }

    const {
        values,
        errors,
        handleChange,
        handleSubmit,
    } = useForm(update, validate);

    useEffect(() => {
        data.forEach(value => {
            handleChange("PaymentTypeID", value.PaymentTypeID);
            handleChange("PaymentType", value.PaymentType);
            handleChange("CheckPaymentType", "");
        });
    }, [data]);

    return (
        <div style={{ display: props && props.show ? 'flex' : 'none' }} className="popUpForm">
            <div className="content">
                <div className="Header">
                    <span>ແກ້ໄຂປະເພດຈ່າຍ</span>
                </div>
                <div className="Body">
                    <form onSubmit={handleSubmit} noValidate>
                        <div className="form-row">
                            <div className="col form-group">
                                <span>ປະເພດຈ່າຍ</span>
                                <input className={`input form-control ${errors.PaymentType && 'is-invalid'}`} type="text" name="PaymentType" onChange={(e) => handleInputStatusChange(e)} value={values.PaymentType || ''} required />
                                {errors.PaymentType && (
                                    <p className="invalid-feedback">{errors.PaymentType}</p>
                                )}
                            </div>
                        </div>
                        <div className="footer">
                            <button type="submit" className="btn btn-primary">
                                ບັນທຶກ
                            </button>
                            <button type="button" onClick={(e) => props.onClick(false)} className="btn btn-danger" data-dismiss="modal" aria-label="Close">
                                ກັບຄືນ
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default UpdatePaymentType;
